/**
 * @generated SignedSource<<458c3aa9108b357d04885dae908b4e3e>>
 * @relayHash c82d4bc74d3968b5677f2b4e7e151b40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138

import type { ConcreteRequest, Query } from 'relay-runtime';
export type versionStatus_versionHasReleaseNoteQuery$variables = {
  versionId: string;
};
export type versionStatus_versionHasReleaseNoteQuery$data = {
  readonly jira: {
    readonly version: {
      readonly hasReleaseNote?: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type versionStatus_versionHasReleaseNoteQuery = {
  response: versionStatus_versionHasReleaseNoteQuery$data;
  variables: versionStatus_versionHasReleaseNoteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasReleaseNote"
    }
  ],
  "type": "JiraVersion"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "versionStatus_versionHasReleaseNoteQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "versionStatus_versionHasReleaseNoteQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138",
    "metadata": {},
    "name": "versionStatus_versionHasReleaseNoteQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ac12222b76ff5150d612ed35c9605c2c";

export default node;
